<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a routerLink="/"
          class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/images/logo-t.png"
              alt=""
              height="22" />
          </span>
          <span class="logo-lg">
            <img src="assets/images/logo-dark.png"
              alt=""
              height="17" />
          </span>
        </a>

        <a routerLink="/"
          class="logo logo-light">
          <span class="logo-sm">
            <img src="assets/images/logo-t.png"
              alt=""
              height="22" />
          </span>
          <span class="logo-lg">
            <img src="assets/images/logo-light.png"
              alt=""
              height="40" />
          </span>
        </a>
      </div>
      <button type="button"
        class="btn btn-sm px-3 font-size-16 header-item"
        [ngClass]="{ 'd-none': theme === 'horizontal' }"
        id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>
    </div>

    <div class="d-flex">
      <div class="dropdown d-none d-lg-inline-block ms-1">
        <button type="button"
          class="btn header-item noti-icon waves-effect"
          data-bs-toggle="fullscreen"
          (click)="fullscreen()">
          <i class="bx bx-fullscreen"></i>
        </button>
      </div>

      <div class="dropdown d-inline-block"
        dropdown>
        <button type="button"
          class="btn header-item noti-icon"
          id="page-header-notifications-dropdown"
          dropdownToggle>
          <i class="bx bx-bell bx-tada"></i>
          <span class="badge bg-danger rounded-pill"
            *ngIf="list?.length">{{
            list?.length
            }}</span>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
          aria-labelledby="page-header-notifications-dropdown"
          *dropdownMenu>
          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">알림</h6>
              </div>
              <div class="col-auto">
                <div style="cursor: pointer"
                  (click)="deleteAll(); $event.stopPropagation()"
                  class="small">
                  전체 삭제
                </div>
              </div>
            </div>
          </div>
          <ngx-simplebar style="position: relative; height: 230px">
            <div style="
                margin-top: 80px;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100%;
                font-size: 14px;
                color: #888;
              "
              *ngIf="list?.length < 1">
              알림이 없습니다.
            </div>
            <div (click)="moveUrl(item)"
              class="text-reset notification-item"
              [class.unread]="item.pushStatus === 'SENT'"
              *ngFor="let item of list; let i = index">
              <div class="notification-item d-flex align-items-center p-3 mb-2">
                <div class="flex-grow-1">
                  <p class="notification-content">{{ item.body }}</p>
                  <p class="text-muted font-size-12 mb-1">
                    <i class="mdi mdi-clock-outline me-1"></i>
                    {{ formatDateTime(item.createdAt) }}
                  </p>
                </div>
                <div class="d-flex align-items-center">
                  <span class="badge badge-sm me-2"
                    [ngClass]="{
                      'bg-warning': item.pushStatus === 'PENDING',
                      'bg-info': item.pushStatus === 'SENT',
                      'bg-success': item.pushStatus === 'READ'
                    }">
                    {{ item.pushStatus === 'PENDING' ? '대기' : item.pushStatus === 'SENT' ? '발송' : '읽음' }}
                  </span>
                  <i style="cursor: pointer"
                    (click)="deleteAlarm(item, i); $event.stopPropagation()"
                    class="bx bxs-trash trash-icon"></i>
                </div>
              </div>
            </div>
          </ngx-simplebar>
        </div>
      </div>
    </div>
  </div>
</header>